import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import EFPicture from '@elem/ui/ef-picture';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import { useEffect, useRef, useState } from 'react';
import { Navigation, Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useGlobal } from '@/utils/useGlobal';

const Through: React.FC = () => {
    const { gtm } = useGlobal();

    const { locale = 'us' } = getLocal();
    const { t } = useLang('Through');
    const swiperRef = useRef<any>(null);
    const logoList = [
        {
            src: 'https://websiteoss.ecoflow.com/upload/image/1749611701494/logo1.png',
        },
        {
            src: 'https://websiteoss.ecoflow.com/upload/image/1749611701266/logo2.png',
        },
        {
            src: 'https://websiteoss.ecoflow.com/upload/image/1749611701759/logo3.png',
        },
        {
            src: 'https://websiteoss.ecoflow.com/upload/image/1749611701985/logo4.png',
        },
    ];

    const list: { [key: string]: any }[] = [
        {
            pc: {
                us: 'https://websiteoss.ecoflow.com/upload/image/1749627727462/story1.jpg',
                ca: 'https://websiteoss.ecoflow.com/upload/image/1749627727462/story1.jpg',
            },
            title: t('list_title_1'),
            desc: t('list_desc_1'),
        },
        {
            pc: {
                us: 'https://websiteoss.ecoflow.com/upload/image/1749627727676/story2.jpg',
                ca: 'https://websiteoss.ecoflow.com/upload/image/1754029064798/%E8%83%BD%E7%99%BB%E7%81%BD%E5%AE%B3%E6%94%AF%E6%8F%B4%E5%AF%8C%E5%B1%B1%E6%B6%88%E9%98%B2%E9%9A%8A%20(1).jpg',
            },
            title: t('list_title_2'),
            desc: t('list_desc_2'),
        },
        {
            pc: {
                us: 'https://websiteoss.ecoflow.com/upload/image/1749627727103/story3.jpg',
                ca: 'https://websiteoss.ecoflow.com/upload/image/1754029064797/Ottenhofen%20Sponsoring.jpg',
            },
            title: t('list_title_3'),
            desc: t('list_desc_3'),
        },
        {
            pc: {
                us: 'https://websiteoss.ecoflow.com/upload/image/1749627727252/story4.jpg',
                ca: 'https://websiteoss.ecoflow.com/upload/image/1754029064773/CSR%2C%20SNOWSTORM.jpg',
            },
            title: t('list_title_4'),
            desc: t('list_desc_4'),
        },
    ];

    const handlePrev = () => {
        swiperRef.current?.slidePrev();
    };

    const handleNext = () => {
        swiperRef.current?.slideNext();
    };

    // slidesPerView 如果是大于1024px 的屏幕就说3个，如果是小于1124px 的屏幕就是 auto

    const [slidesPerView, setSlidesPerView] = useState<'auto' | number>('auto');
    const getSlidesPerView = () => {
        if (window.innerWidth > 1024) {
            return 3;
        }
        return 'auto';
    };

    // 监听屏幕宽度变化 改变slierPerView
    useEffect(() => {
        const handleResize = () => {
            setSlidesPerView(getSlidesPerView());
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <div className={`${styles.Through} GtmModuleData-section`} data-section-id={'powerPreparedness-Through'} data-section-title={t('title')}>
            <EcoSectionCommon
                title={t('title')}
                desc={t.rich('desc', {
                    link: (text: string) => <a href={`https://www.ecoflow.com/${locale}/powerforall`}>{text}</a>,
                })}
            />

            <div className="logo-wrapper page-layout desktop-max">
                {logoList.map((item, index) => (
                    <div className={'logo-item logo-item-' + (index + 1)} key={index}>
                        <EFPicture src={item.src} />
                    </div>
                ))}
            </div>
            {/* 单独渲染第二个 */}
            <div className={'logo-item-row-2'}>
                <EFPicture src={logoList[1].src} />
            </div>

            <div className="list-wrapper page-layout">
                <Swiper
                    onSwiper={(swiper) => {
                        swiperRef.current = swiper;
                    }}
                    slidesPerView={slidesPerView}
                    spaceBetween={24}
                    modules={[Navigation, Scrollbar]}
                    scrollbar={{
                        hide: false,
                        draggable: true,
                        dragSize: 25,
                        snapOnRelease: true,
                    }}
                    navigation={{
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    }}
                    initialSlide={0}
                    onSlideChange={(swiper) => {
                        if (swiper.previousIndex < swiper.activeIndex) {
                            gtm.push({
                                event: 'uaEvent',
                                event_name: 'product_detail_page',
                                list_name: 'Power Through With Your Reliable Partner',
                                button_name: 'Right switch',
                            });
                        } else {
                            gtm.push({
                                event: 'uaEvent',
                                event_name: 'product_detail_page',
                                list_name: 'Power Through With Your Reliable Partner',
                                button_name: 'Left switch',
                            });
                        }
                    }}
                >
                    {list.map((item, index) => (
                        <SwiperSlide className="list-item" key={index}>
                            <EFPicture src={item.pc[locale]} />
                            <div className="list-item-box">
                                <div className="list-item-title">{item.title}</div>
                                <div className="list-item-desc">{item.desc}</div>
                            </div>
                        </SwiperSlide>
                    ))}
                    <div className="swiper-button-prev" onClick={handlePrev} />
                    <div className="swiper-button-next" onClick={handleNext} />
                </Swiper>
            </div>
            <div className="page-space"></div>
        </div>
    );
};

export default Through;
